<template>
  <div class="claim-page">
    <div class="claim-card">
      <i class="mdi mdi-domain claim-icon"></i>
      <h2>Claim your corporate account</h2>
      <p v-if="!claimed" class="claim-sub">You've been added as a corporate client on Flockr. Sign in to take ownership of your company profile — you'll be able to view every invoice from your suppliers in one place and settle them online.</p>
      <p v-else class="claim-success">{{ companyName }} is now linked to your account.</p>

      <template v-if="!loggedIn">
        <p>Sign in or create an account first, then come back to this link.</p>
        <button class="claim-btn" @click="goLogin()">Sign in / Register</button>
      </template>
      <template v-else-if="!claimed">
        <p class="claim-muted">Signed in as <strong>{{ userName }}</strong>. Click below to claim.</p>
        <button class="claim-btn" :disabled="working" @click="claim()"><span v-if="working"><i class="mdi mdi-loading mdi-spin"></i> Claiming…</span><span v-else>Claim {{ tokenPreview }}</span></button>
        <p v-if="error" class="claim-error">{{ error }}</p>
      </template>
      <template v-else>
        <button class="claim-btn" @click="goInvoices()">Open My Invoices</button>
      </template>
    </div>
  </div>
</template>

<script>
import { executeJson, flocker } from "@/api";
export default {
  name: "ClaimCorporateAccountPage",
  data(){return{ working:false, claimed:false, error:"", companyName:"" }},
  computed:{
    token(){ return this.$route.params.token; },
    tokenPreview(){ return "(token " + (this.token || "").slice(0,8) + "…)"; },
    loggedIn(){ return !!sessionStorage.getItem("userId"); },
    userName(){ return sessionStorage.getItem("userName") || "you"; },
  },
  methods:{
    goLogin(){
      sessionStorage.setItem("post_login_redirect", "/claim/" + this.token);
      this.$router.push("/login");
    },
    async claim(){
      this.working = true; this.error = "";
      try {
        const r = await executeJson({ function: "claimCorporateAccount", token: this.token, userId: sessionStorage.getItem("userId") }, flocker);
        if (r.data && r.data.success) { this.claimed = true; this.companyName = r.data.data.companyName || "Your company"; }
        else this.error = (r.data && r.data.message) || "Claim failed";
      } catch (e){ this.error = e.message; }
      this.working = false;
    },
    goInvoices(){ this.$router.push("/my-invoices"); },
  }
};
</script>

<style scoped>
.claim-page{min-height:100vh;background:#F5EEDE;display:flex;align-items:center;justify-content:center;padding:30px 16px}
.claim-card{background:#FFFFFF;border:1px solid #D8C9A3;border-radius:14px;padding:34px;max-width:480px;text-align:center;box-shadow:0 6px 24px rgba(0,0,0,.06)}
.claim-icon{font-size:54px;color:#8B5A2B}
.claim-card h2{margin:8px 0 6px;font-size:20px;color:#1A1A1A}
.claim-sub{color:#5C4533;font-size:14px;line-height:1.55;margin:0 0 18px}
.claim-muted{color:#6B6356;font-size:13px;margin:0 0 12px}
.claim-success{color:#1F6B1F;font-size:14px;margin:0 0 18px;font-weight:600}
.claim-error{color:#B71C1C;font-size:13px;margin-top:10px}
.claim-btn{background:#8B3F1E;color:#FFF;border:none;padding:12px 24px;border-radius:7px;font-weight:600;cursor:pointer;font-size:14px}
.claim-btn:hover{background:#6E3217}
.claim-btn:disabled{opacity:.7;cursor:not-allowed}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .claim-card { padding: 24px 20px; border-radius: 12px; }
  .claim-icon { font-size: 44px; }
  .claim-card h2 { font-size: 18px; }
  .claim-sub { font-size: 13px; }
  .claim-btn { padding: 12px 22px; font-size: 14px; width: 100%; }
}
</style>
